import { Comment, CommentsData, CommentAuthor } from './comments.domain';
import * as g from 'generated/graphql';

type GetCommentsResponse = g.GetCommentsQuery['getComments'][0];

export const toCommentAuthor = (
  gqlAuthor: GetCommentsResponse['author'],
): CommentAuthor => ({
  userId: gqlAuthor.id,
  userName: gqlAuthor.username,
  userAvatarURL: gqlAuthor.profilePicture,
});

export const toThreadComment = (
  gqlThreadComment: NonNullable<GetCommentsResponse['thread']>[0],
): Comment => ({
  id: gqlThreadComment.id,
  contentId: gqlThreadComment.contentId,
  threadId: gqlThreadComment.threadId || null,
  text: gqlThreadComment.text,
  author: toCommentAuthor(gqlThreadComment.author),
  hidden: gqlThreadComment.hidden,
  date: gqlThreadComment.updatedAt || gqlThreadComment.createdAt,
  thread: null,
});

export const toComment = (gqlComment: GetCommentsResponse): Comment => ({
  id: gqlComment.id,
  contentId: gqlComment.contentId,
  threadId: gqlComment.threadId || null,
  text: gqlComment.text,
  author: toCommentAuthor(gqlComment.author),
  hidden: gqlComment.hidden,
  date: gqlComment.updatedAt || gqlComment.createdAt,
  thread: gqlComment.thread ? gqlComment.thread.map(toThreadComment) : null,
});

export const toCommentsData = (
  gqlComments: GetCommentsResponse[],
  contentId: string,
): CommentsData => ({
  comments: gqlComments.map(toComment),
  contentId,
});
